export class RefundRequestMessageInput {
    IdRefundRequest:  string | null;
    Message: string|null;
}